export default "__VITE_ASSET__CXq9hcov__"